import React, {PropsWithChildren, useEffect} from "react";
import ReactDOM from 'react-dom';
import "./FullScreenModal.scss"

export interface FullScreenModalProps extends PropsWithChildren {
    customClass?: string;
}

export const FullScreenModal: React.FunctionComponent<FullScreenModalProps> = (props) => {
    useEffect(() => {
        const previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = previousBodyOverflow;
        };
    }, [false]);

    const getModalLayout = () => {
        return <div className={'full-screen-modal ' + (props.customClass ? props.customClass : '')}>
            <div className='full-screen-modal-content'>
                {props.children}
            </div>
        </div>
    }
    return ReactDOM.createPortal(getModalLayout(), document.body);
}